import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Vaata sarnaseid tooteid

  <span style="color:#85c1dc;">**FI:**</span>
  Katso vastaavia tuotteita

  <span style="color:#85c1dc;">**RU:**</span>
  Смотреть схожие товары
*/
/* @__NO_SIDE_EFFECTS__ */
const m1994 = msg(
  mf`Vaata sarnaseid tooteid`,
  mf`Katso vastaavia tuotteita`,
  mf`Смотреть схожие товары`,
)

export { m1994 as 'w.module.product.use_wordless_search' }